<ion-toolbar [hidden]="!(match && match.sets?.length > 1)">

    <ion-segment class="content-width" (ionChange)="selectSet($event)" [value]="0">
        <ion-segment-button value="0">
            <ion-label>Match</ion-label>
        </ion-segment-button>
        <ion-segment-button value="1">
            <ion-label>Set 1</ion-label>
        </ion-segment-button>
        <ion-segment-button value="2">
            <ion-label>Set 2</ion-label>
        </ion-segment-button>
        <ion-segment-button value="3" [hidden]="!(match.sets?.length > 2)">
            <ion-label>Set 3</ion-label>
        </ion-segment-button>
        <ion-segment-button value="4" *ngIf="match.sets?.length === 4">
            <ion-label>Set 4</ion-label>
        </ion-segment-button>
        <ion-segment-button value="5" *ngIf="match.sets?.length === 5">
            <ion-label>Set 5</ion-label>
        </ion-segment-button>
    </ion-segment>
</ion-toolbar>

<ion-grid class="content-width" *ngIf="match">

    <!-- ******** General ******** -->
    <ion-row class="row ion-text-center" [style.background]="rowStyle">
        <ion-col size="4">
            {{ participantSide1 }}
        </ion-col>
        <ion-col size="4">{{ 'General' | translate }}</ion-col>
        <ion-col size="4">
            {{ participantSide2 }}
        </ion-col>
    </ion-row>

    <!-- Total points won -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.pointsWon }}/{{ side1Stats.pointsWon + side2Stats.pointsWon }} ({{ getPercentage(side1Stats.pointsWon, side1Stats.pointsWon + side2Stats.pointsWon) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side1Stats.pointsWon, side1Stats.pointsWon + side2Stats.pointsWon)" reversed></ion-progress-bar>
        </ion-col>
        <ion-col size="4">{{ 'Total Points Won' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.pointsWon }}/{{ side1Stats.pointsWon + side2Stats.pointsWon }} ({{ getPercentage(side2Stats.pointsWon, side1Stats.pointsWon + side2Stats.pointsWon) }}%)
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getDecimal(side2Stats.pointsWon, side1Stats.pointsWon + side2Stats.pointsWon)"></ion-progress-bar>
        </ion-col>
    </ion-row>
    <!-- Short Rally -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.shortRally }}
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getProgressBarValue([side1Stats.shortRally, side2Stats.shortRally], 1)" reversed></ion-progress-bar>
        </ion-col>
        <ion-col size="4">{{ 'Short Rally' | translate }}<br />(0-4)</ion-col>
        <ion-col size="4">
            {{ side2Stats.shortRally }}
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getProgressBarValue([side1Stats.shortRally, side2Stats.shortRally], 2)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Medium Rally -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.mediumRally }}
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getProgressBarValue([side1Stats.mediumRally, side2Stats.mediumRally], 1)" reversed></ion-progress-bar>
        </ion-col>
        <ion-col size="4">{{ 'Medium Rally' | translate }}<br />(5-8)</ion-col>
        <ion-col size="4">
            {{ side2Stats.mediumRally }}
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getProgressBarValue([side1Stats.mediumRally, side2Stats.mediumRally], 2)"></ion-progress-bar>

        </ion-col>
    </ion-row>

    <!-- Long Rally -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.longRally }}
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getProgressBarValue([side1Stats.longRally, side2Stats.longRally], 1)" reversed></ion-progress-bar>
        </ion-col>
        <ion-col size="4">{{ 'Long Rally' | translate }}<br />(9+)</ion-col>
        <ion-col size="4">
            {{ side2Stats.longRally }}
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getProgressBarValue([side1Stats.longRally, side2Stats.longRally], 2)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Winner -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.W }}
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getProgressBarValue([side1Stats.W, side2Stats.W], 1)" reversed></ion-progress-bar>
        </ion-col>
        <ion-col size="4">{{ 'Winners' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.W }}
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getProgressBarValue([side1Stats.W, side2Stats.W], 2)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Forced error -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.F }}
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getProgressBarValue([side1Stats.F, side2Stats.F], 1)" reversed></ion-progress-bar>
        </ion-col>
        <ion-col size="4">{{ 'Forced Errors' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.F }}
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getProgressBarValue([side1Stats.F, side2Stats.F], 2)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Unforced error -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.U }}
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getProgressBarValue([side1Stats.U, side2Stats.U], 1)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ 'Unforced Errors' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.U }}
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getProgressBarValue([side1Stats.U, side2Stats.U], 2)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Aggressive margin -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">{{ side1Stats.W + side2Stats.F - side1Stats.U }}</ion-col>
         <ion-col size="4">{{ 'Aggressive Margin' | translate }}</ion-col>
        <ion-col size="4">{{ side2Stats.W + side1Stats.F - side2Stats.U }}</ion-col>
    </ion-row>

    <!-- ******* Serve ******* -->
    <ion-row class="row ion-text-center" [style.background]="rowStyle">
        <ion-col size="4">
            {{participantSide1}}
        </ion-col>
         <ion-col size="4">{{ 'Serve' | translate }}</ion-col>
        <ion-col size="4">
            {{participantSide2}}
        </ion-col>
    </ion-row>

    <!-- Aces -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.A }}
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getProgressBarValue([side1Stats.A, side2Stats.A], 1)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ 'Aces' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.A }}
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getProgressBarValue([side1Stats.A, side2Stats.A], 2)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Double faults -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.DF }}
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getProgressBarValue([side1Stats.DF, side2Stats.DF], 1)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ 'Double Faults' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.DF }}
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getProgressBarValue([side1Stats.DF, side2Stats.DF], 2)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- First serve percentage -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.firstServePlayed }}/{{ side1Stats.firstServePlayed + side1Stats.secondServePlayed }} ({{ getPercentage(side1Stats.firstServePlayed, side1Stats.firstServePlayed + side1Stats.secondServePlayed)}}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side1Stats.firstServePlayed, (side1Stats.firstServePlayed + side1Stats.secondServePlayed))" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ '1st Serve %' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.firstServePlayed }}/{{ side2Stats.firstServePlayed + side2Stats.secondServePlayed }} ({{ getPercentage(side2Stats.firstServePlayed, side2Stats.firstServePlayed + side2Stats.secondServePlayed)}}%)
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getDecimal(side2Stats.firstServePlayed, side2Stats.firstServePlayed + side2Stats.secondServePlayed)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- First serve points won -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.firstServeWon }}/{{ side1Stats.firstServePlayed }} ({{ getPercentage(side1Stats.firstServeWon, side1Stats.firstServePlayed) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side1Stats.firstServeWon, side1Stats.firstServePlayed)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ '1st Serve Points Won' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.firstServeWon }}/{{ side2Stats.firstServePlayed }} ({{ getPercentage(side2Stats.firstServeWon, side2Stats.firstServePlayed) }}%)
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getDecimal(side2Stats.firstServeWon, side2Stats.firstServePlayed)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Second serve points won -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.secondServeWon }}/{{ side1Stats.secondServePlayed }} ({{ getPercentage(side1Stats.secondServeWon, side1Stats.secondServePlayed) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side1Stats.secondServeWon, side1Stats.secondServePlayed)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ '2nd Serve Points Won' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.secondServeWon }}/{{ side2Stats.secondServePlayed }} ({{ getPercentage(side2Stats.secondServeWon, side2Stats.secondServePlayed) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side2Stats.secondServeWon, side2Stats.secondServePlayed)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Total serve points won -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.serveWon }}/{{ side1Stats.servePlayed }} ({{ getPercentage(side1Stats.serveWon, side1Stats.servePlayed) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side1Stats.serveWon, side1Stats.servePlayed)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ 'Total Serve Points Won' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.serveWon }}/{{ side2Stats.servePlayed }} ({{ getPercentage(side2Stats.serveWon, side2Stats.servePlayed) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side2Stats.serveWon, side2Stats.servePlayed)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- ******** Return ********-->
    <ion-row class="row ion-text-center" [style.background]="rowStyle">
        <ion-col size="4">
            {{participantSide1}}
        </ion-col>
         <ion-col size="4">{{ 'Return' | translate }}</ion-col>
        <ion-col size="4">
            {{participantSide2}}
        </ion-col>
    </ion-row>

    <!-- Returns made -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.returnMade }}/{{ side2Stats.servePlayed - side2Stats.DF }} ({{ getPercentage(side1Stats.returnMade, (side2Stats.servePlayed - side2Stats.DF)) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side1Stats.returnMade, side2Stats.servePlayed - side2Stats.DF)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ 'Returns Made' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.returnMade }}/{{ side1Stats.servePlayed - side1Stats.DF }} ({{ getPercentage(side2Stats.returnMade, (side1Stats.servePlayed - side1Stats.DF)) }}%)
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getDecimal(side2Stats.returnMade, side1Stats.servePlayed - side1Stats.DF)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- First serve return won -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side2Stats.firstServePlayed - side2Stats.firstServeWon }}/{{ side2Stats.firstServePlayed }} ({{ getPercentage(side2Stats.firstServePlayed - side2Stats.firstServeWon, side2Stats.firstServePlayed) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side2Stats.firstServePlayed - side2Stats.firstServeWon, side2Stats.firstServePlayed)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ '1st Serve Return Points Won' | translate }}</ion-col>
        <ion-col size="4">
            {{ side1Stats.firstServePlayed - side1Stats.firstServeWon }}/{{ side1Stats.firstServePlayed }} ({{ getPercentage(side1Stats.firstServePlayed - side1Stats.firstServeWon, side1Stats.firstServePlayed) }}%)
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getDecimal(side1Stats.firstServePlayed - side1Stats.firstServeWon, side1Stats.firstServePlayed)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Second serve return points won -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side2Stats.secondServePlayed - side2Stats.secondServeWon }}/{{ side2Stats.secondServePlayed }} ({{ getPercentage((side2Stats.secondServePlayed - side2Stats.secondServeWon), side2Stats.secondServePlayed) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side2Stats.secondServePlayed - side2Stats.secondServeWon, side2Stats.secondServePlayed)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ '2nd Serve Return Points Won' | translate }}</ion-col>
        <ion-col size="4">
            {{ side1Stats.secondServePlayed - side1Stats.secondServeWon }}/{{ side1Stats.secondServePlayed }} ({{ getPercentage((side1Stats.secondServePlayed - side1Stats.secondServeWon), side1Stats.secondServePlayed) }}%)
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getDecimal(side1Stats.secondServePlayed - side1Stats.secondServeWon, side1Stats.secondServePlayed)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Total return points won -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.returnWon }}/{{ side2Stats.servePlayed }} ({{ getPercentage(side1Stats.returnWon, side2Stats.servePlayed) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side1Stats.returnWon, side2Stats.servePlayed)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ 'Total Return Points Won' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.returnWon }}/{{ side1Stats.servePlayed }} ({{ getPercentage(side2Stats.returnWon, side1Stats.servePlayed) }}%)
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getDecimal(side2Stats.returnWon, side1Stats.servePlayed)"></ion-progress-bar>
        </ion-col>
    </ion-row>

    <!-- Break points won -->
    <ion-row class="row ion-text-center">
        <ion-col size="4">
            {{ side1Stats.breakPointConverted }}/{{ side1Stats.breakPoint }} ({{ getPercentage(side1Stats.breakPointConverted, side1Stats.breakPoint) }}%)
            <ion-progress-bar [style.--background]="side1Progress" [style.--progress-background]="side1Color" [value]="getDecimal(side1Stats.breakPointConverted, side1Stats.breakPoint)" reversed></ion-progress-bar>
        </ion-col>
         <ion-col size="4">{{ 'Break Points Won' | translate }}</ion-col>
        <ion-col size="4">
            {{ side2Stats.breakPointConverted }}/{{ side2Stats.breakPoint }} ({{ getPercentage(side2Stats.breakPointConverted, side2Stats.breakPoint) }}%)
            <ion-progress-bar [style.--background]="side2Progress" [style.--progress-background]="side2Color" [value]="getDecimal(side2Stats.breakPointConverted, side2Stats.breakPoint)"></ion-progress-bar>
        </ion-col>
    </ion-row>

</ion-grid>

@if (!!authService.authUserSignal()) {
    <ion-button (click)="downloadCsv()" expand="block" fill="clear" shape="round">
        {{ 'Download' | translate }}
    </ion-button>
}